// extracted by mini-css-extract-plugin
module.exports = {"sectionSearch":"Index_sectionSearch_3WdT8","searchList":"Index_searchList_1xjiU"};